import React, { useContext, useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ThemeContext } from '../context/ThemeContext';

const Navbar = () => {
  const { authData, logout } = useContext(AuthContext);
  const { token, userName } = authData;
  const { theme, toggleTheme } = useContext(ThemeContext);
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const firstName = userName?.trim() ? userName.trim().split(' ')[0] : 'Você';
  const navLinkClassName = ({ isActive }) =>
    `nav-chip${isActive ? ' is-active' : ''}`;

  return (
    <header className="app-header">
      <div className="app-header__inner surface-blur">
        <Link className="app-brand" to="/">
          <span className="app-brand__mark">
            <i className="bi bi-basket2-fill"></i>
          </span>
          <span>
            Lista de Compras
            <small>Organize, compartilhe e acompanhe</small>
          </span>
        </Link>

        <button
          className="menu-toggle"
          type="button"
          onClick={() => setIsMenuOpen((currentState) => !currentState)}
          aria-label="Abrir navegação"
          aria-expanded={isMenuOpen}
        >
          <i className={`bi ${isMenuOpen ? 'bi-x-lg' : 'bi-list'}`}></i>
        </button>

        <div className={`app-nav ${isMenuOpen ? 'is-open' : ''}`}>
          <nav className="app-nav__links">
            <NavLink className={navLinkClassName} to="/">
              Início
            </NavLink>
            {token && (
              <NavLink className={navLinkClassName} to="/listas">
                Minhas listas
              </NavLink>
            )}
            {token && (
              <NavLink className={navLinkClassName} to="/perfil">
                Perfil
              </NavLink>
            )}
          </nav>

          <div className="app-nav__actions">
            <button
              type="button"
              className="subtle-button button-compact"
              onClick={toggleTheme}
              aria-label="Alternar tema"
            >
              <i
                className={`bi ${
                  theme === 'dark' ? 'bi-sun-fill' : 'bi-moon-stars-fill'
                }`}
              ></i>
              {theme === 'dark' ? 'Modo claro' : 'Modo escuro'}
            </button>

            {token ? (
              <>
                <span className="user-pill">
                  <i className="bi bi-person-circle"></i>
                  Olá, {firstName}
                </span>
                <button
                  type="button"
                  className="primary-button button-compact"
                  onClick={logout}
                >
                  Sair
                </button>
              </>
            ) : (
              <>
                <Link className="subtle-button button-compact" to="/register">
                  Criar conta
                </Link>
                <Link className="primary-button button-compact" to="/login">
                  Entrar
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
